module.exports = __webpack_public_path__ + "img/a1-s30.466b0593.jpg";